(function () {
  const MODAL_ID = 'consentModal';
  const UPDATE_MODAL_ID = 'updateNoticeModal';

  const modal = document.getElementById(MODAL_ID);
  const updateModal = document.getElementById(UPDATE_MODAL_ID);
  const acceptBtn = document.getElementById('consentAccept');
  const updateAcceptBtn = document.getElementById('updateNoticeAccept');
  const declineBtn = document.getElementById('consentDecline');
  const openLink = document.getElementById('openConsent');
  const termsLink = document.getElementById('consentTermsLink');

  function openModal() {
    if (!modal) return;
    modal.style.display = 'flex';
    document.body.classList.add('noscroll');
  }

  function closeAllModals() {
    if (modal) modal.style.display = 'none';
    if (updateModal) updateModal.style.display = 'none';
    document.body.classList.remove('noscroll');
  }

  function showUpdateNotice() {
    if (!updateModal) {
      closeAllModals();
      return;
    }
    if (modal) modal.style.display = 'none';
    updateModal.style.display = 'flex';
  }

  openModal();

  if (acceptBtn) {
    acceptBtn.addEventListener('click', showUpdateNotice);
  }

  if (updateAcceptBtn) {
    updateAcceptBtn.addEventListener('click', closeAllModals);
  }

  if (declineBtn) {
    declineBtn.addEventListener('click', closeAllModals);
  }

  if (openLink) {
    openLink.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  }

  if (termsLink) {
    termsLink.addEventListener('click', (e) => {
      e.preventDefault();
      alert('أضف هنا رابط صفحة الشروط/الخصوصية الخاصة بك.');
    });
  }
})();
